export default {
  verbose: false,
  async: false,
  autoStart: false,
  state: {
    size: 15,
    strokeStyle: "black",
    fillStyle: "black",
    lineCap: "round",
    lineJoin: "round",
    lineWidth: 1,
    speed: 0.5,
    font: "20px sans-serif",
    textAlign: "left",
    textBaseline: "alphabetic",
  },
  image:
    "data:image/svg+xml,%3Csvg width='50' height='50' viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg' xmlns:bx='https://boxy-svg.com'%3E%3Cdefs%3E%3Cbx:grid x='0' y='0' width='50' height='50'/%3E%3C/defs%3E%3Cpath d='M 5 0 L 0 10 L 5 8 L 10 10 L 5 0 Z' style=''/%3E%3C/svg%3E",
};
